<style lang="less" scoped>
  .in-sec {
    width: 1200px; margin: 0 auto;
    text-align: center; padding: 79px 0 160px 0;
  }
  h2 {
    margin: 0 auto; line-height: 60px; display: inline-block;
    border: 2px solid #8cf7fb; font-family: 'DINPro-B'; font-size: 26px;
    padding: 0 53px; border-radius: 32px; background-color: #fff;
    box-shadow: 0 5px 10px rgba(51, 55, 64, .09);
  }
  ul {
    text-align: left; padding-top: 65px;
    li {
      display: inline-block; padding: 15px;
      img {
        display: block; border: 1px solid #f0f0f0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .in-sec {
      width: 100%; padding: 40px 0 50px 0;
    }
    h2 {
      font-size: 13px; line-height: 30px; border-radius: 15px;
      padding: 0 25px;
    }
    ul {
      width: calc(100% - 20px); margin: 0 auto;
      li {
        width: calc(100% / 2); padding: 7px;
        img {
          width: 100%;
        }
      }
    }
  }
</style>

<template lang="pug">
  .partner-container
    .in-sec
      h2 PARTNER
      ul
        li(v-for=("item in partners"))
          img(:src="`${item.img}`")
</template>

<script>
export default {
  props: {
    partners: Array,
    default: null,
  },
};
</script>
